import React from 'react'

export default function UnmovingProductsInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        #content { background-color: whitesmoke; }

        .report-wrapper { border: solid 0.5px lightgrey; }

        #unmoving-products-container {
          font-size: 1rem;
          background-color: white;
          box-sizing: border-box;
          padding: 25px;
        }

        .unmoving-products-table { width: 100%; }
        .unmoving-products-table th:nth-child(1), .inventory-table td:nth-child(1) { width: 50%; }
        .unmoving-products-table th:nth-child(2), .inventory-table td:nth-child(2) { width: 30%; }
        .unmoving-products-table th:nth-child(3), .inventory-table td:nth-child(3) { width: 20%; }

        .unmoving-products-table .sortable-header { padding: 5px; }
        .unmoving-products-table .sortable-header:hover { background-color: #D2D6F7; }
        .unmoving-products-table th { padding: 10px 0; }

        .dates-header-container { display: flex; }
        .dates-header-container .date-left { flex: 1; }
        .dates-header-container .date-right {
          flex: 1;
          text-align: right;
        }

      `}
      </style>
    </React.Fragment>
  )
}
